var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-editor-block quote"},[_c('div',{ref:"input",domProps:{"innerHTML":_vm._s(_vm.initValue)},on:{"input":_vm.onInput}})])}
var staticRenderFns = []

export { render, staticRenderFns }